import { render } from "./SportsVOD.vue?vue&type=template&id=6da2728d&scoped=true"
import script from "./SportsVOD.vue?vue&type=script&lang=js"
export * from "./SportsVOD.vue?vue&type=script&lang=js"

import "./SportsVOD.vue?vue&type=style&index=0&id=6da2728d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da2728d"]])

export default __exports__